import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchConfig = () => apiClient.get("/config").then((r) => r.data);
export const fetchProducts = (category) =>
  apiClient
    .get("/products", { params: category ? { category } : {} })
    .then((r) => r.data);
export const fetchProduct = (slug) =>
  apiClient.get(`/products/${slug}`).then((r) => r.data);
export const fetchBlogPosts = () =>
  apiClient.get("/blog/posts").then((r) => r.data);
export const fetchBlogPost = (slug) =>
  apiClient.get(`/blog/posts/${slug}`).then((r) => r.data);
export const submitQuote = (data) =>
  apiClient.post("/quote", data).then((r) => r.data);
const pendingContacts = new Map();
export const submitContact = async (data) => {
  const signature = JSON.stringify(data);
  if (!pendingContacts.has(signature)) pendingContacts.set(signature, window.crypto.randomUUID());
  const r = await apiClient.post("/contact", data, { headers: {
    "Idempotency-Key": pendingContacts.get(signature), "X-Contact-Page": window.location.pathname,
  } });
  pendingContacts.delete(signature);
  return r.data;
};
export const createCheckout = (data) =>
  apiClient.post("/checkout/session", data).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  apiClient.get(`/checkout/status/${sessionId}`).then((r) => r.data);

// Phase 4B — public webshop endpoints
export const fetchWebshopCatalog = (params = {}) =>
  apiClient.get("/webshop/products", { params }).then((r) => r.data);
export const fetchWebshopCategories = () =>
  apiClient.get("/webshop/categories").then((r) => r.data);
export const createWebshopCheckoutSession = (payload) =>
  apiClient.post("/webshop/checkout/create-session", payload).then((r) => r.data);
export const fetchOrderBySession = (sessionId) =>
  apiClient.get(`/webshop/orders/by-session/${sessionId}`).then((r) => r.data);
export const fetchFeaturedProducts = (limit = 3) =>
  apiClient.get("/webshop/products/featured", { params: { limit } }).then((r) => r.data);
